import "@hotwired/turbo-rails";

import "./controllers";
import "./channels";

import toastr from "toastr";
window.toastr = toastr;
